import { useEffect, useState } from "react";
import Seo from "../components/Seo";
import { PageHero } from "../components/common/Section";
import PostCard from "../components/common/PostCard";
import { api } from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  const [cat, setCat] = useState("All");
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);
  const cats = ["All", ...new Set((posts || []).map((p) => p.category))];
  const shown = (posts || []).filter((p) => cat === "All" || p.category === cat);
  return (
    <>
      <Seo title="Blog & Market Insights" path="/blog" />
      <PageHero eyebrow="Blog & Market Insights" title="Insights for informed investors." text="Educational articles on investing, insurance, planning and markets from the Quantora research desk." />
      <section className="bg-slate-100/70 py-20">
        <div className="container-q">
          <div className="mb-10 flex flex-wrap gap-2">
            {cats.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`blog-filter-${c.toLowerCase().replace(/\s/g, "-")}`}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors ${cat === c ? "bg-navy text-white" : "bg-white text-slate-600 hover:bg-slate-200"}`}>{c}</button>
            ))}
          </div>
          {posts && !shown.length && <p className="text-slate-500" data-testid="blog-empty">No articles yet.</p>}
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="blog-list">
            {shown.map((p, i) => <PostCard key={p.slug} post={p} index={i} />)}
          </div>
        </div>
      </section>
    </>
  );
}
